import axios from 'axios';
import * as Sentry from '@sentry/react';

import { APPLY_URL, COMPANY_URL, PUBLIC_URL, PUBLIC_PREVIEW_URL, URL_SUFFIX } from './urls';

const createRequestObj = (url, method, data, options) => {
  let req = {
    url,
    method,
    data,
    responseType: options.responseType || 'json',
  };

  if (options.responseType === 'blob') {
    // Have to unset the 'application/json' content type
    // when we fetch blobs from s3.
    req.transformRequest = [
      (data, headers) => {
        delete headers.common['Content-Type'];
        return data;
      },
    ];
  }
  return req;
};

const request = async (url, method = 'get', data = {}, options = {}) => {
  const obj = createRequestObj(url, method, data, options);
  try {
    const res = await axios(obj);
    return {
      data: res.data,
      status: res.status,
      error: false,
    };
  } catch (error) {
    const cpy = { ...error };
    if (cpy && cpy.response) {
      const errorObj = {
        data: cpy.response.data || cpy.response.statusText || 'Error',
        status: cpy.response.status,
        error: true,
      };
      if (process.env.NODE_ENV === 'production' && cpy.response.status !== 404) {
        Sentry.captureException(error, {
          extra: errorObj,
        });
      }
      return errorObj;
    }
  }
  return { error: true };
};

const Applications = {
  submitForm: (company, job_id, data) =>
    request(`${APPLY_URL}${company.toLowerCase()}/${job_id}/`, 'post', data),
};

const Companies = {
  loadCompany: (company) => request(`${COMPANY_URL}${company.toLowerCase()}${URL_SUFFIX}`),
};

const Jobs = {
  load: (company) => request(`${PUBLIC_URL}${company.toLowerCase()}/jobs${URL_SUFFIX}`),
  loadDetail: (company, id) =>
    request(`${PUBLIC_URL}${company.toLowerCase()}/jobs/${id}${URL_SUFFIX}`),
  loadForm: (company, id) =>
    request(`${PUBLIC_URL}${company.toLowerCase()}/jobs/${id}/form${URL_SUFFIX}`),
  loadDetailPreview: (company, id, preview) =>
    request(`${PUBLIC_PREVIEW_URL}${company}/jobs/${id}/?preview=${preview}`),
  loadFormPreview: (company, id, preview) =>
    request(`${PUBLIC_PREVIEW_URL}${company}/jobs/${id}/form/?preview=${preview}`),
};

export default {
  applications: Applications,
  companies: Companies,
  jobs: Jobs,
};
